<div class="relative bg-black-7 aspect-square w-full">
  <div
    *ngIf="!showInitials && profile?.photo"
    data-qa="avatar-photo"
    class="absolute overflow-hidden inset-0">
    <img
      [src]="profile.photo"
      alt="avatar"
      (error)="profile.photo = errorImageLink"
    >
  </div>
  <div
    *ngIf="showInitials"
    data-qa="avatar-initials"
    class="absolute inset-0 flex text-center justify-center items-center {{initialsCssClasses}}">
    {{ initials }}
  </div>
</div>
